import script from "./GlobalGroupNameCell.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalGroupNameCell.vue?vue&type=script&setup=true&lang=js"

import "./GlobalGroupNameCell.vue?vue&type=style&index=0&id=1911a2c0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1911a2c0"]])

export default __exports__